module.exports = __webpack_public_path__ + "img/white_GZ_logo_Eng.84431ab1.svg";